import { OpenIDConnectScheme, } from '@nuxtjs/auth-next';
import { CONFIG } from '@shared/environment/environment';
export default class OpenIDConnectClaimsScheme extends OpenIDConnectScheme {
    constructor($auth, options, ...defaults) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const { CONFIG } = require('@shared/environment/environment');
        const { apiUrl, keycloakUrl, keycloakClientId, keycloakConfigPath, keycloakLogoutPath } = CONFIG;
        const oidcTokenPath = `/oauth/jwt/get`;
        const oidcUserPath = `/auth/me`;
        super($auth, {
            name: options.name,
            responseType: 'code',
            grantType: 'authorization_code',
            clientId: keycloakClientId,
            token: {
                property: 'access',
                name: 'API-Authorization',
            },
            refreshToken: {
                property: 'refresh_token',
                data: 'refresh_token',
                maxAge: 60 * 60 * 24, // 24 hours
            },
            idToken: {
                property: 'id_token',
            },
            user: {
                property: false,
            },
            endpoints: {
                token: new URL(oidcTokenPath, apiUrl).href,
                userInfo: new URL(oidcUserPath, apiUrl).href,
                configuration: new URL(keycloakConfigPath, keycloakUrl).href,
                logout: new URL(keycloakLogoutPath, keycloakUrl).href,
            },
        }, ...defaults);
    }
    async fetchUser() {
        if (!this.check(false).valid) {
            return;
        }
        const { data } = await this.$auth.requestWith(this.name, {
            url: this.options.endpoints.userInfo,
        });
        this.$auth.setUser(data);
        await this.$auth.ctx.store.dispatch('settings/fetchMenuEntries', undefined, { root: true });
    }
    logout() {
        const idToken = this.idToken.get();
        if (typeof idToken === 'string' && this.options.endpoints.logout) {
            const redirectUrl = new URL('/logout', CONFIG.backofficeUrl);
            const url = new URL(this.options.endpoints.logout);
            url.searchParams.set('client_id', this.options.clientId.toString());
            url.searchParams.set('id_token_hint', idToken);
            url.searchParams.set('post_logout_redirect_uri', redirectUrl.href);
            window.location.href = url.href;
        }
        else {
            super.logout();
        }
    }
}
